import axios from 'axios'
import MedicalTest from 'model/MedicalTest'

export const searchTextSelector = async (text: string, page: number) => {
  try {
    const response = await axios.get(
      (window as any).config.server + '/searchMedicalTests?name=' + text + '&page=' + page,
    )
    const data = response.data

    const medicalTests = data.map((a: MedicalTest) => {
      return {
        category: a.category,
        subCategory: a.subCategory,
        code: a.code,
        name: a.name,
      }
    })

    let savedItems = window.sessionStorage.getItem('medical_tests_list')

    if (savedItems) {
      savedItems = JSON.parse(savedItems)
      window.sessionStorage.setItem(
        'medical_tests_list',
        JSON.stringify(
          savedItems?.concat(medicalTests.map((v: any) => ({ label: v.name, value: v }))),
        ),
      )
      let response = savedItems?.concat(medicalTests.map((v: any) => ({ label: v.name, value: v })))
      return response
    } else {
      window.sessionStorage.setItem(
        'medical_tests_list',
        JSON.stringify(medicalTests.map((v: any) => ({ label: v.name, value: v }))),
      )
      return medicalTests.map((v: any) => ({ label: v.name, value: v }))
    }
  } catch (e) {
    console.log(` Axios request failed: ${e}`)
    return []
  }
}
